/**
 * 判断编辑态是否应该把焦点拉回 textarea。
 *
 * 例如点击画布空白区、只读输入框或工具栏按钮后，activeElement 可能是 body、
 * 不可输入控件或按钮；此时用户继续敲字，预期仍然是在编辑当前文本，所以需要恢复焦点。
 *
 * 如果用户已经点进另一个可编辑 input、textarea 或 contenteditable，说明焦点有新的输入目标，
 * 这里就不能抢回 textarea，避免打断外部控件输入。
 *
 * @param activeElement - 当前聚焦的元素
 * @param textarea - 要恢复焦点的 textarea 元素
 * @returns 是否应该恢复焦点
 */
export const shouldRestoreTextareaFocus = (activeElement: Element | null, textarea: HTMLTextAreaElement) => {
    if (!activeElement || activeElement === document.body || activeElement === textarea) return true;
    if (activeElement instanceof HTMLInputElement) return activeElement.readOnly || activeElement.disabled;
    if (activeElement instanceof HTMLTextAreaElement) return activeElement.readOnly || activeElement.disabled;
    if (activeElement instanceof HTMLSelectElement) return activeElement.disabled;
    if (activeElement instanceof HTMLElement && activeElement.isContentEditable) return false;
    return true;
};
